import dayjs from "dayjs";
import { DeliveryStatus } from "@/app/shared/orders/dashboard/delivery-status";
import DispatchPlanning from "@/app/shared/orders/dashboard/dispatch-planning";
import CustomerStata from "@/app/shared/orders/dashboard/fleet-status";
import DeliveredOrders from "@/app/shared/orders/dashboard/open-sales-order";
import StatCards from "@/app/shared/orders/dashboard/stat-cards";
import TopShipmentCountries from "@/app/shared/orders/dashboard/top-shipment-countries";
import { fetchOrders } from "@/server/api-services";
import { Order, OrderStatus } from "@/types";
import cn from "@/utils/class-names";
import { useState, useEffect } from "react";


export default function LogisticsDashboard() {
    const [orders, setOrders] = useState<Order[]>([]);
    const [activeTab, setActiveTab] = useState<"overview" | "map">("overview");

    useEffect(() => {
        loadOrders();
    }, []);

    async function loadOrders() {
        const response = await fetchOrders();

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Order[];

        // Map string status to OrderStatus enum
        data = data.map((order) => ({
            ...order,
            status: OrderStatus[order.status as keyof typeof OrderStatus],
        }));

        setOrders(data);
    }
    return (
        <div className="@container">
            <div className="grid grid-cols-12 gap-6 3xl:gap-8">
                <StatCards orders={orders} className="col-span-full" />

                <div className="col-span-full flex items-center gap-3 border-b border-gray-200">
                    <button
                        type="button"
                        onClick={() => setActiveTab("overview")}
                        className={cn(
                            "relative -mb-px border-b-2 px-3 py-2 text-sm font-semibold transition-colors",
                            activeTab === "overview"
                                ? "border-primary text-primary bg-primary/10 rounded-t-md"
                                : "border-transparent text-gray-500 hover:text-gray-900",
                        )}
                    >
                        Overview
                    </button>
                    <button
                        type="button"
                        onClick={() => setActiveTab("map")}
                        className={cn(
                            "relative -mb-px border-b-2 px-3 py-2 text-sm font-semibold transition-colors",
                            activeTab === "map"
                                ? "border-primary text-primary bg-primary/10 rounded-t-md"
                                : "border-transparent text-gray-500 hover:text-gray-900",
                        )}
                    >
                        Map
                    </button>
                </div>

                {activeTab === "overview" ? (
                    <>
                        <DeliveredOrders
                            orders={orders}
                            className="col-span-full @3xl:col-span-6 @[1429px]:col-span-4"
                        />
                        <DispatchPlanning
                            orders={orders}
                            className="col-span-full @3xl:col-span-6 @[1429px]:col-span-4"
                        />
                        <CustomerStata
                            orders={orders}
                            className="col-span-full @3xl:col-span-6 @[1429px]:col-span-4"
                        />
                    </>
                ) : (
                    <TopShipmentCountries
                        orders={orders}
                        className="col-span-full h-150 @4xl:col-span-12 @7xl:col-span-12 @7xl:[&_.recharts-responsive-container]:!w-11/12 @[88rem]:[&_.recharts-responsive-container]:!w-full"
                    />
                )}

                {/* <TopCustomer orders={orders} className="col-span-full @3xl:col-span-full @5xl:col-span-full @7xl:col-span-8" /> */}
            </div>            
        </div>
    );
}
